import styled from '@emotion/styled'
import dynamic from 'next/dynamic'

const LearningPathIcon = dynamic(
  () => import('@public/static/icons/advantageous/LearningPathIcon')
)
const StarsIcon = dynamic(
  () => import('@public/static/icons/advantageous/StarsIcon')
)
const NewAudienceIcon = dynamic(
  () => import('@public/static/icons/advantageous/NewAudienceIcon')
)
import { colors, fontFamilies } from '@configs/styles/config'
import { useTranslation } from 'react-i18next'

type Props = {}

const DifferentPlatform = ({}: Props) => {
  const { t } = useTranslation('advantageous')

  const list = [
    {
      icon: LearningPathIcon,
      title: t('learningPathTitle'),
      description: t('learningPathDescription'),
    },
    {
      icon: StarsIcon,
      title: t('aiIntegrationTitle'),
      description: t('aiIntegrationDescription'),
    },
    {
      icon: NewAudienceIcon,
      title: t('newAudienceTitle'),
      description: t('newAudienceDescription'),
    },
  ]

  return (
    <Container>
      <Wrapper>
        <Header>{t('howEdugramDifferent')}</Header>

        <ContentContainer>
          {list.map((item) => (
            <ContentContainerItem key={item.description}>
              <ContentContainerIcon>
                <item.icon />
              </ContentContainerIcon>
              <ContentContainerTitle>{item.title}</ContentContainerTitle>
              <ContentContainerDescription>
                {item.description}
              </ContentContainerDescription>
            </ContentContainerItem>
          ))}
        </ContentContainer>
      </Wrapper>
    </Container>
  )
}

export default DifferentPlatform

const Container = styled.div`
  min-height: 660px;
  /* background-color: ${(props) => (props.y < 520 ? '#E7EAFF' : '')}; */
  transition: all 0.2s ease-in-out;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  max-width: 1600px;
  @media screen and (max-width: 596px) {
    padding: 0rem 1rem;
  }
`
const Header = styled.div`
  font-family: ${fontFamilies.medium};
  font-size: 48px;
  line-height: 48px;
  text-align: center;
  max-width: 640px;
  margin: 4.5rem 0rem;
  color: ${colors.uguPurple};
  @media screen and (max-width: 596px) {
    font-size: 36px;
    line-height: 36px;
  }
`
const ContentContainer = styled.div`
  @media screen and (min-width: 821px) {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    flex-wrap: wrap;
    gap: 3.5rem;
    max-width: 1440px;
    flex-direction: row;
  }
  display: flex;
  gap: 3.5rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
`
const ContentContainerItem = styled.div`
  width: 356px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  height: 356px;
  @media screen and (max-width: 386px) {
    width: 100%;
  }
`
const ContentContainerIcon = styled.div`
  height: 160px;
`
const ContentContainerTitle = styled.div`
  font-family: ${fontFamilies.bold};
  font-weight: 600;
  font-size: 48px;
  line-height: 72px;
  text-align: center;
  color: ${colors.uguPurple};
  @media screen and (max-width: 596px) {
    font-size: 32px;
    line-height: 72px;
  }
`
const ContentContainerDescription = styled.div`
  font-family: ${fontFamilies.regular};
  font-size: 20px;
  line-height: 32px;
  color: ${colors.uguPurple};
  text-align: center;
  @media screen and (max-width: 596px) {
    font-size: 16px;
    line-height: 32px;
  }
`
